export default __webpack_public_path__ + "static/media/card.a7f147e2.jpg";